import { Component, ElementRef, ViewChild } from '@angular/core';
import { AlertController, IonicPage, LoadingController, ModalController, NavController, NavParams, Platform } from 'ionic-angular';
import { ProductosProvider } from '../../providers/productos/productos';
import { CentroDeCostosProvider } from '../../providers/centro-de-costos/centro-de-costos';
import { CompaniasProvider } from '../../providers/companias/companias';
import { AuthService } from '../../providers/auth-service';
import { UtilsProvider } from '../../providers/utils/utils';
import { NUBE_AWS } from '../../config/url.servicio';
import { Storage } from '@ionic/storage'
import { EntidadesProvider } from '../../providers/entidades/entidades';
import { Observable } from 'rxjs/Observable';
import { InformesProvider } from '../../providers/informes/informes';
@IonicPage()
@Component({
  selector: 'page-egresos-ingresos-diarios',
  templateUrl: 'egresos-ingresos-diarios.html',
  providers: [ AuthService, EntidadesProvider ]
})
export class EgresosIngresosDiariosPage {
  @ViewChild('fileInp') fileInput: ElementRef;
  @ViewChild('imagenProducto') imagenProducto: ElementRef;
  egresosingresosdiarios = []
  valorUnitario=0
  valorUnitarioString= ""
  cantidad=1
  detalle
  imagen
  egresosDiariosId
  loader
  typeImg
  imagenProd
  editarEgresosDiarios
  allItems: any;
  buscar: any = "";
  companiasId:any = null
  fecha = new Date();
  public usuarioId:any;
  conceptosEgresosId;
  selectedImage: string;
  showImage: boolean = false;
  fileUpload(event) {
    var reader = new FileReader();

    reader.onload = (e) => {
      this.imagenProducto['src'] = e.target['result'];
      this.imagen = e.target['result'];
    };

    reader.readAsDataURL(event.srcElement.files[0]);
    this.typeImg = event.srcElement.files[0].type
    this.imagenProd = event.srcElement.files[0]
  }

  onClick() {
    this.fileInput.nativeElement.click();
  }
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  public picture;
  public codigoBarra:any =""
  @ViewChild('canvas') canvasElement : ElementRef;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: ProductosProvider,
    private storage: Storage,
    public loadingCtrl: LoadingController,
    public serviciocentrodecosto: CentroDeCostosProvider ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    public utils:UtilsProvider,
    public servicioEntidades: EntidadesProvider,
    public servicioInformes:InformesProvider,
    public mensajeria:UtilsProvider,
  ) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
          var valor = val['companiasId']
          this.companiasId = valor
          this.egresosingresosdiarios = []
          this.buscar = ""
          this.cargarEgresosIngresos();
          this.limpiar();
          this.buscarUsuario();

        }
      })
  }

  ngAfterViewInit() {
}

 searchEdit(cantidadafn:any,i:any){
  this.storage.get('companiasId').then((val) => {
   let companiasId = val
   let valorUnitario = this.valorUnitario
   let cantidad = this.cantidad

 });
}

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  getItems(event: any): void {
    if(!this.allItems){
      let valores = this.egresosingresosdiarios
      this.allItems = valores;
    }
      this.egresosingresosdiarios = this.allItems.filter((item) => {
        return item.nombre.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
      });
}

cargarEgresosIngresos() {
    this.egresosDiariosId = []
    this.buscar = ""

    this.servicio.buscarEgresosDiariosCompania(this.companiasId)
    .subscribe(
      res => {
        this.egresosingresosdiarios = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
        this.allItems = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
      },

      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar los ingresos - egresos, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )
  }

  guardar() {

    this.buscar = ""
    this.allItems = []
    let datos: any = {}
    if(this.editarEgresosDiarios) {
      const fecha = new Date(this.fecha); // Crear objeto de fecha
      fecha.setHours(fecha.getHours() - 5); // Restar 5 horas
      const fechaIngreso = fecha.toISOString(); // Convertir la fecha a un formato legible y válido
      datos = {
        valorUnitario: this.valorUnitario,
        cantidad: this.cantidad,
        detalle: this.detalle,
        usuariosId: this.usuarioId,
        fechaEgreso:fechaIngreso,
        conceptosEgresosId:this.conceptosEgresosId[0].value,
        imagen: this.imagenProd,
        egresosDiariosId: this.egresosDiariosId
      }
      this.editarEgresosIngresos(datos)
    } else {
      const fecha = new Date(this.fecha); // Crear objeto de fecha
      fecha.setHours(fecha.getHours() - 5); // Restar 5 horas
      const fechaIngreso = fecha.toISOString(); // Convertir la fecha a un formato legible y válido
      datos = {
        valorUnitario: this.valorUnitario,
        cantidad: this.cantidad,
        detalle: this.detalle,
        usuariosId: this.usuarioId,
        fechaEgreso:fechaIngreso,
        conceptosEgresosId:this.conceptosEgresosId[0].value,
        imagen: this.imagenProd
      }
      this.guardarEgresosIngresos(datos)
    }
  }

  editarEgresosIngresos(values) {
    values['egresosDiariosId'] = this.egresosDiariosId
    this.buscar =""
    this.allItems = []
      if(this.typeImg == undefined || (this.typeImg = 'image/png' && this.imagen == '') ){
        const fecha = new Date(this.fecha); // Crear objeto de fecha
        fecha.setHours(fecha.getHours() - 5); // Restar 5 horas
        const fechaIngreso = fecha.toISOString(); // Convertir la fecha a un formato legible y válido
        let datos: any = {
          queHago: "A",
          nombreTabla: "egresosDiarios",
          name: "dataDynamicCrud",
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          valorUnitario: values.valorUnitario,
          cantidad: values.cantidad,
          detalle: values.detalle,
          usuariosId: this.usuarioId,
          fechaEgreso:fechaIngreso,
          conceptosEgresosId:this.conceptosEgresosId[0].value,
          egresosDiariosId: values.egresosDiariosId,
        }
        this.servicio.editar(datos, this.typeImg).subscribe((data: any)=> {
          this.utils.mensajeMuestro('Egresos ingresos','Modificado Exitosamente!','success')
          this.procesarResultado()
          this.typeImg
          this.imagenProd
        },(error) => {
          this.mostrarMensajeDeError('No se pudo actualizar los Egresos ingresos, intente luego')
          this.procesarResultado()
      })
      } else {
        this.servicio.guardarImagen(values, this.typeImg).subscribe((data: any)=> {
          const fecha = new Date(this.fecha); // Crear objeto de fecha
          fecha.setHours(fecha.getHours() - 5); // Restar 5 horas
          const fechaIngreso = fecha.toISOString(); // Convertir la fecha a un formato legible y válido
          let datos: any = {
            queHago: "A",
            nombreTabla: "egresosDiarios",
            name: "dataDynamicCrud",
            imagen:data.link,
            valorUnitario: values.valorUnitario,
            cantidad: values.cantidad,
            detalle: values.detalle,
            usuariosId: this.usuarioId,
            fechaEgreso:fechaIngreso,
            conceptosEgresosId:this.conceptosEgresosId[0].value,
            egresosDiariosId: values.egresosDiariosId,
          }
          this.servicio.editar(datos, this.typeImg).subscribe((data: any)=> {
            this.utils.mensajeMuestro('Egresos ingresos','Modificado Exitosamente!','success')
            this.procesarResultado()
            this.typeImg
            this.imagenProd
            this.navCtrl.setRoot('HomePage', {imagen: true, pages: 'ProductosPage'});
          },(error) => {
            this.mostrarMensajeDeError('No se pudo actualizar los Egresos ingresos, intente luego')
            this.procesarResultado()
        })
        }, (error) => {
          this.mostrarMensajeDeError('No se pudo actualizar el producto, intente luego')
          this.procesarResultado()
        })
      }
  }

  guardarEgresosIngresos(datos){
    if(NUBE_AWS) {
      if(this.typeImg == undefined || (this.typeImg = 'image/png' && this.imagen == '') ){
        const fecha = new Date(this.fecha); // Crear objeto de fecha
        fecha.setHours(fecha.getHours() - 5); // Restar 5 horas
        const fechaIngreso = fecha.toISOString(); // Convertir la fecha a un formato legible y válido

        let datos: any = {
          queHago: "I",
          nombreTabla: "egresosDiarios",
          name: "dataDynamicCrud",
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          valorUnitario: this.valorUnitario,
          cantidad: this.cantidad,
          detalle: this.detalle,
          usuariosId: this.usuarioId,
          fechaEgreso:fechaIngreso,
          conceptosEgresosId:this.conceptosEgresosId[0].value,
          egresosDiariosId: this.egresosDiariosId == undefined ? "0" : this.egresosDiariosId
        }
        this.servicio.guardar(datos, this.typeImg).subscribe((data: any)=> {
          this.utils.mensajeMuestro('Egresos ingresos','Guardado Exitosamente!','success')
          this.procesarResultado()
          this.typeImg
          this.imagenProd
        },(error) => {
          this.mostrarMensajeDeError('No se pudo guardar los Egresos ingresos, intente luego')
          this.procesarResultado()
      })
      } else {
        const fecha = new Date(this.fecha); // Crear objeto de fecha
        fecha.setHours(fecha.getHours() - 5); // Restar 5 horas
        const fechaIngreso = fecha.toISOString(); // Convertir la fecha a un formato legible y válido

        this.servicio.guardarImagen(datos, this.typeImg).subscribe((data: any)=> {
          let datos: any = {
            queHago: "I",
            nombreTabla: "egresosDiarios",
            name: "dataDynamicCrud",
            imagen:data.link,
            valorUnitario: this.valorUnitario,
            cantidad: this.cantidad,
            detalle: this.detalle,
            usuariosId: this.usuarioId,
            fechaEgreso:fechaIngreso,
            conceptosEgresosId:this.conceptosEgresosId[0].value,
            egresosDiariosId: data.egresosDiariosId == undefined ? "0" : data.egresosDiariosId,
          }
          this.servicio.guardar(datos, this.typeImg).subscribe((data: any)=> {
            this.utils.mensajeMuestro('Egresos ingresos','Guardado Exitosamente!','success')
            this.procesarResultado()
            this.typeImg
            this.imagenProd
            this.navCtrl.setRoot('HomePage', {imagen: true, pages: 'ProductosPage'});
          },(error) => {
            this.mostrarMensajeDeError('No se pudo guardar los Egresos ingresos, intente luego')
            this.procesarResultado()
        })
        }, (error) => {
          this.mostrarMensajeDeError('No se pudo guardar los Egresos ingresos, intente luego')
          this.procesarResultado()
        })
      }
    } else {
    this.servicio.guardar(datos, this.typeImg)
    .subscribe(
      res => {
        this.utils.mensajeMuestro('Egresos ingresos','Guardado Exitosamente!','success')
        this.procesarResultado()
      },
      err => this.mostrarMensajeDeError('No se pudo guardar los Egresos ingresos, intente luego')
    )
   }
  }


  limpiar() {
    this.valorUnitario = 0
    this.cantidad = 1
    this.detalle = ""
    this.imagenProd = ""
    this.imagen = ""
    this.buscar =""
    this.allItems = []
    this.egresosDiariosId = 0
  }

  editar(item){

    this.valorUnitario = item.valorUnitario
    this.cantidad = item.cantidad
    this.detalle = item.detalle
    this.imagen = item.imagen
    this.egresosDiariosId = item.egresosDiariosId
    this.editarEgresosDiarios = true
    this.buscar =""
    this.allItems = []
  }

  eliminar(item) {
    this.utils.mensajeConfirmacionDos('Egresos ingresos','¿Está Seguro de borrar el registro?','question','Si','No')
     .then((loQuiereBorrar: boolean) => {
      if (loQuiereBorrar) {
        this.buscar =""
        this.allItems = []

        this.servicio.eliminarEgresosIngresos(item)
        .subscribe(
          res => {
            this.utils.mensajeMuestro('Egresos ingresos','Eliminado Exitosamente!','success')
            this.procesarResultado()
          },
          err => this.utils.mensajeMuestro('Egresos ingresos','No se eliminó los Egresos ingresos','error')
          )
      }
      else {
        this.utils.mensajeMuestro('Productos','No se eliminó el registro','warning')
      }
    })
  }

  procesarResultado() {
    this.limpiar()
    this.cargarEgresosIngresos()
  }

  mostrarMensajeDeError(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Error',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();
  }

  buscarUsuario(){
    if(this.usuarioId===undefined){
          this.storage.get('usuariosId').then((usuarioIngreso) => {
            this.usuarioId = usuarioIngreso
        })
      }
   }
   public requestAutocompleteItems = (text: string): Observable<Response> => {
    return this.servicioEntidades.buscarConceptosEgresosPorCompania(text, this.companiasId)
  };
  descargarArchivoExcel(){


    if(this.egresosingresosdiarios.length > 0){
          let data = this.egresosingresosdiarios
          this.servicioInformes.exportToExcel(data, 'egresos-ingresos-diarios')
          .then((result: any) => {
              console.log('result', result)
            }).catch((error)=> {
              console.log('error', error)
            })
        }else{
          this.mensajeria.mensajeMuestro('No se logro la información','Advertencia!','Advertencia')
          return false
        }

  }

  openImage(imageUrl: string) {
    this.selectedImage = imageUrl;
    this.showImage = true;
  }
  closeImage() {
    this.showImage = false;
  }
  DECIMAL_SEPARATOR  = '.'
  GROUP_SEPARATOR = ','

  format(valString) {
    if (!valString) {
        this.valorUnitario = 0
        return '';
    }
    let val = valString.toString();
    try {
        this.valorUnitario = Number(val.replace(/,/g, ''))
    } catch (e) {
        this.valorUnitario = 0
    }

    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
};

unFormat(val) {
    if (!val) {
        return '';
    }
    val = val.replace(/^0+/, '');

    if (this.GROUP_SEPARATOR === ',') {
        return val.replace(/,/g, '');
    } else {
        return val.replace(/\./g, '');
    }
};
searchSimple(cantidadNueva:any){
  setTimeout(async () => {
      let cantidadafnSimpleConvert: any = cantidadNueva !== undefined && cantidadNueva.value !== undefined ? cantidadNueva.value : ''
      const valorSinComas = cantidadafnSimpleConvert.replace(/,/g, '');

      // Convertir la cadena a un número
      let cantidadafnSimple = parseInt(valorSinComas, 10);
      if(Number(cantidadafnSimple)==0 || isNaN(cantidadafnSimple) ){
       return
     }

     let cantidadInput = cantidadafnSimple;

      if (isNaN(cantidadInput)) {
        cantidadInput = 0;
        cantidadafnSimple = 0;
        return
      }

     //let cantidad = Number(cantidadafnSimple)
    return

   },1000)
 }

}



// WEBPACK FOOTER //
// ./src/pages/egresos-ingresos-diarios/egresos-ingresos-diarios.ts